import * as CustomAxios from './CustomAxios'

const ReportError = {

  notifyReportError: (details: any) =>
    CustomAxios.requests.post<any>(process.env.REACT_APP_API_URL + `/api/ReportError/Add`, details),
}

const WebUser = {

  requestLogin: (value: any) => CustomAxios.requests.put<any>(process.env.REACT_APP_API_URL + `/api/WebUser/Login`, value),
  forgotPassword: (value: any) => CustomAxios.requests.put<any>(process.env.REACT_APP_API_URL + `/api/WebUser/ForgotPassword`, value),
  confirmAccount: (value: any) => CustomAxios.requests.put<any>(process.env.REACT_APP_API_URL + `/api/WebUser/ConfirmAccount`, value),
  resetPassword: (value: any) => CustomAxios.requests.put<any>(process.env.REACT_APP_API_URL + `/api/WebUser/ResetPassword`, value),

  createAccount: (value: any) => CustomAxios.requests.post<any>(process.env.REACT_APP_API_URL + `/api/WebUser/CreateAccount`, value),

  getAccountDetails: (userNo: number) =>
    CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/api/WebUser/Details/${userNo}`),
  updateAccountDetails: (value: any) => CustomAxios.requests.put<any>(process.env.REACT_APP_API_URL + `/api/WebUser/UpdateAccount`, value),

  getAppVersion: () => CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/api/WebUser/Version`),
}

const Postcode = {

  getSuburbByKeyword: (keyword: string) =>
    CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/api/Postcode/Search/${keyword}`),
}

const Home= {

  getSalesDashboard: (userNo: number, wholeNo: number) =>
    CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/api/Home/Dashboard`),
}


const Enquiry = {

  getOdataEnquiryList: (mode: string, filter: string) =>
    CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/odata/Enquiry?mode=${mode}&$count=true&${filter}`),

  getEnquiryFromJob: (enquiryNo: number) =>
    CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/api/ClientEnquiry/FromJob/${enquiryNo}`),

  updateEnquiryDetails: (details: any) =>
    CustomAxios.requests.put<any>(process.env.REACT_APP_API_URL + `/api/ClientEnquiry/Update`, details),
  updateEnquiryTradeAccount: (details: any) =>
    CustomAxios.requests.put<any>(process.env.REACT_APP_API_URL + `/api/ClientEnquiry/UpdateTrade`, details),
}

const Job = {

  getOdataJobList: (mode: string, searchText: string, filter: string) =>
    CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/odata/Job?mode=${mode}&searchText=${searchText}&$count=true&${filter}`),

  getJobForDialog: (jobNo: number) =>
    CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/api/JobProcess/Dialog/${jobNo}`),

  getCustomerJobList: (customerNo: number) =>
    CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/api/JobProcess/CustomerJobs/${customerNo}`),

  addJobAndCustomer: (details: any) =>
    CustomAxios.requests.post<any>(process.env.REACT_APP_API_URL + `/api/JobProcess/AddJobCustomer`, details),
  addJob: (details: any) =>
    CustomAxios.requests.post<any>(process.env.REACT_APP_API_URL + `/api/JobProcess/Add`, details),
  updateJobDetails: (details: any) =>
    CustomAxios.requests.put<any>(process.env.REACT_APP_API_URL + `/api/JobProcess/Update`, details),
  updateExternalRepairDetails: (details: any) =>
    CustomAxios.requests.put<any>(process.env.REACT_APP_API_URL + `/api/JobProcess/UpdateExternal`, details),

  uploadJobImage: (details: any) =>
    CustomAxios.requests.put<any>(process.env.REACT_APP_API_URL + `/api/JobProcess/UploadImage`, details),
  deleteJobImage: (details: any) =>
    CustomAxios.requests.put<any>(process.env.REACT_APP_API_URL + `/api/JobProcess/DeleteImage`, details),

  getJobImages: (jobNo: number) =>
    CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/api/JobProcess/Images/${jobNo}`),

  getPrintForInvoice: (customerNo: number) =>
    CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/api/JobProcess/PrintInvoice/${customerNo}`),

  getPaymentLink: (jobNo: number) =>
    CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/api/JobProcess/PayLink/${jobNo}`),
}

const TaskJob = {

  getTaskJobList: (jobNo: number) =>
    CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/api/TaskJob/List/${jobNo}`),

  addTaskJob: (details: any) =>
    CustomAxios.requests.post<any>(process.env.REACT_APP_API_URL + `/api/TaskJob/Add`, details),
  updateTaskJob: (details: any) =>
    CustomAxios.requests.put<any>(process.env.REACT_APP_API_URL + `/api/TaskJob/Update`, details),
  deleteTaskJob: (details: any) =>
    CustomAxios.requests.put<any>(process.env.REACT_APP_API_URL + `/api/TaskJob/Delete`, details),
}

const AdminCompany = {

  getCompanyDetails: () =>
    CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/api/AdminCompany/Details`), 
  updateCompanyDetails: (details: any) =>
    CustomAxios.requests.put<any>(process.env.REACT_APP_API_URL + `/api/AdminCompany/Update`, details),
}

const AdminAccount = {

  getAccountList: (userNo: number) =>
    CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/api/AdminAccount/List/${userNo}`),
  addAccount: (details: any) =>
    CustomAxios.requests.post<any>(process.env.REACT_APP_API_URL + `/api/AdminAccount/Add`, details),
  updateAccount: (details: any) =>
    CustomAxios.requests.put<any>(process.env.REACT_APP_API_URL + `/api/AdminAccount/Update`, details),
  deleteAccount: (details: any) =>
    CustomAxios.requests.put<any>(process.env.REACT_APP_API_URL + `/api/AdminAccount/Delete`, details),
}

const Customer= {

  getOdataCustomerList: (mode: string, searchText: string, filter: string) =>
    CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/odata/Customer?mode=${mode}&searchText=${searchText}&$count=true&${filter}`),

  getCustomerDetailsByMobile: (mobile: string) =>
    CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/api/Customer/Mobile/${mobile}`),

  getCustomerForDialog: (customerNo: number) =>
    CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/api/Customer/Dialog/${customerNo}`),
  addCustomer: (details: any) =>
    CustomAxios.requests.post<any>(process.env.REACT_APP_API_URL + `/api/Customer/Add`, details),
  updateCustomer: (details: any) =>
    CustomAxios.requests.put<any>(process.env.REACT_APP_API_URL + `/api/Customer/Update`, details),
}


const ApiAgent = {
  ReportError,
  WebUser,
  Postcode,

  Home,
  Enquiry,
  Job,
  TaskJob, 
  Customer,

  AdminCompany,
  AdminAccount,
}

export default ApiAgent;
